/* eslint-disable @typescript-eslint/naming-convention */
import { React, useState, useEffect } from 'react'
import { useOutletContext } from "react-router-dom"
import { useSignal } from "@preact/signals-react"

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { logout, refreshSession } from '../state/actions/sessionActions.js'
import { sessionSignal, sessionLoadedSignal, sessionErrorSignal, sessionExpirationTimestampSignal, sessionRefreshingSignal } from '../state/signals/sessionSignals.js'

import { SESSION_TIMEOUT_INTERVAL } from '../utils/constants.js'
import { digitalClock } from '../utils/datetime'
import { notifyException } from '../state/actions/notificationActions.js';

const InactivityModal = () => {

	const { user, config, accessToken, permissionMasks, permissions } = useOutletContext()

	const showModalSignal = useSignal(false)

	const secondsRemaining = (sessionExpirationTimestampSignal.value - Date.now()) / 1000
	const [expiration, setExpiration] = useState(secondsRemaining)
	useEffect(
		() => {
			let print = false
			const getExpiration = () => {
				const expiration = (sessionExpirationTimestampSignal.value - Date.now()) / 1000
				return expiration
			}
			setExpiration(getExpiration())
			const timer = setInterval(
				() => {
					const expiration = getExpiration()
					if (print) {
						console.log("You will be logged out in ".concat(expiration).concat(" seconds"))
					}
					if (expiration < 1) {
						showModalSignal.value = false
						logout(config)
					}
					else if (!sessionRefreshingSignal.value && expiration < SESSION_TIMEOUT_INTERVAL) {
						showModalSignal.value = true
					} else {
						showModalSignal.value = false
					}
					setExpiration(expiration)
				}, 1000
			)
			return () => {
				clearInterval(timer)
			}
		}, [showModalSignal, config]
	)

	if (!sessionLoadedSignal.value || !sessionSignal.value || sessionErrorSignal.value || sessionRefreshingSignal.value) {
		return <></>
	}

	return (
		<Modal show={showModalSignal.value}>
			<Modal.Header>
				<Modal.Title>Inactivity Warning</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div id="inactivityMessage">
					Your session will expire in {digitalClock(expiration)}. Please select Continue to keep your session active.
				</div>
			</Modal.Body>
			<Modal.Footer style={{ marginTop: "0px" }} >
				<Button type="button" className="btn btn-default" onClick={
					() => {
						logout(config)
					}
				}>Sign out</Button>
				<Button
					type="button"
					className="btn btn-primary"
					onClick={
						() => {
							showModalSignal.value = false
							refreshSession(config, accessToken).catch(
								(error) => {
									notifyException(error, "Error refreshing session")
								}
							)
						}
					}>Continue</Button>
			</Modal.Footer>
		</Modal>
	)
}
export default InactivityModal